/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

/**
 * ---
 * private: true
 * ---
 * Generates the style object from the theme and provided additional information
 * @param  {Object} componentTheme The theme variable object.
 * @param  {Object} props the props of the component, the style is applied to
 * @param  {Object} state the state of the component, the style is applied to
 * @return {Object} The final style object, which will be used in the component
 */
const generateStyle = (componentTheme, props) => {
  const maxHeight = props.maxHeight ? {
    maxHeight: props.maxHeight,
    overflow: 'auto'
  } : {};
  return {
    menu: {
      label: 'menu',
      ...maxHeight,
      minWidth: componentTheme.minWidth,
      maxWidth: componentTheme.maxWidth,
      listStyleType: 'none',
      margin: '0',
      padding: '0.25rem 0',
      background: componentTheme.background,
      borderRadius: componentTheme.borderRadius,
      display: 'block',
      position: 'relative',
      '&::before': {
        content: '""',
        position: 'absolute',
        top: '-0.25rem',
        left: '-0.25rem',
        right: '-0.25rem',
        bottom: '-0.25rem',
        border: `${componentTheme.focusBorderWidth} ${componentTheme.focusBorderStyle} ${componentTheme.focusBorderColor}`,
        borderRadius: componentTheme.focusBorderRadius,
        opacity: 0,
        transform: 'scale(0.9)',
        pointerEvents: 'none'
      },
      '&:focus': {
        outline: 'none',
        '&::before': {
          opacity: 1,
          transform: 'scale(1)'
        }
      }
    }
  };
};
export default generateStyle;